"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
const React = __importStar(require("react"));
const Page_Template_1 = require("./utils/Page.Template");
const Page = ({ mode = "main", renderLoading = React.createElement("div", null, "Loading"), api = "", path = "", title = "Title", navigate = "", params = {}, language = "TH", classNameAdd = "", labelAdd = "", labelNoData = "", classNameWrapper = "", classNameTitle = "", classNameError = "", renderHeader = false, renderFooter = false, renderCard = false, renderBody = false, initialState = "", debounceParams = 500, method = "GET", }) => {
    console.warn = function filterWarnings() {
        return;
    };
    console.error = function filterErrors() {
        return;
    };
    if (mode === "main") {
        return (React.createElement(Page_Template_1.PageMain, { api: api, path: path, title: title, renderCard: renderCard, renderLoading: renderLoading, navigate: navigate, language: language, classNameAdd: classNameAdd, labelAdd: labelAdd, labelNoData: labelNoData, classNameWrapper: classNameWrapper, classNameTitle: classNameTitle, classNameError: classNameError, renderHeader: renderHeader, renderFooter: renderFooter, renderBody: renderBody, params: params, initialState: initialState, debounceParams: debounceParams, method: method }));
    }
    else if (mode === "detail") {
        return (React.createElement(Page_Template_1.PageDetail, { api: api, path: path, renderBody: renderBody, params: params, renderLoading: renderLoading, initialState: initialState, method: method }));
    }
    else {
        return null;
    }
};
exports.Page = Page;
